import { useEffect, useState, useRef, useMemo } from 'react';
import { useUser } from '../../../../../../providers/UserProvider';
import magPlus from '../../../pics/icons/magPlus.PNG'
import magMinus from '../../../pics/icons/magMinus.PNG'
import OptionButton from '../OptionButton';
import streaming from '../../../pics/icons/streaming.gif';
import { handleOpenSession, buildNestedFolders, filterFolders } from '../../../constants';
import FolderList from './FolderList';

const DropDownSessionMenu = ({streamingEncounter, setStreamingEncounter, adminView, savedEncounters, socket}) => {
    const [isOpen, setIsOpen] = useState(false);
    const { username, sessionID, setSessionID } = useUser();
    const [collapsedFolders, setCollapsedFolders] = useState({});
    const [search, setSearch] = useState(""); 

    const dropdownRef = useRef(null);

    // Build nested folder structure
    const nestedFolders = useMemo(() => buildNestedFolders(savedEncounters), [savedEncounters]);
    const filteredFolders = useMemo(() => filterFolders(nestedFolders, search), [nestedFolders, search]);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    const handleSetStreamingEncounter = (eGuid, eName, clicked = false) => {
        if(sessionID) {
            //if encounter is clicked
            if(eGuid !== null) {
                // if playerwindow is not open
                if(window.localStorage.getItem("playerViewOpen") === 'false' && clicked) {
                    handleOpenSession(sessionID)
                }
            }
        }

        setStreamingEncounter({encounterGuid: eGuid, encounterName: eName})
    }

    useEffect(() => {
        if(username !== 'Username') {
            console.log("Signed in - Getting Session")
            socket.emit("getCurrentSession");
        } else {
            handleSetStreamingEncounter(null, null)
            setSessionID(null)
            setIsOpen(false)
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [username]);

    useEffect(() => {
        if(savedEncounters.length === 0) { 
            handleSetStreamingEncounter(null, null)
        } else if(sessionID && streamingEncounter.encounterName === '') {
            savedEncounters.forEach(e => {
                if(e.encounterGuid === streamingEncounter.encounterGuid) {
                    handleSetStreamingEncounter(e.encounterGuid, e.encounterName)
                    console.log(`Found stream: ${e.encounterName} - (${e.encounterGuid})`)
                }
            });

        }
    }, [savedEncounters]);

    useEffect(() => {
        if(socket) {
            // Recieve messages from backend
            socket.on('sendSession', (sessionInfo) => {
                setSessionID(sessionInfo.sessionID)
                // streamingEncounterGuid can be empty if nothing is found in the backend
                let log = "No Stream found..."
                savedEncounters.forEach(e => {
                    if(e.encounterGuid === sessionInfo.streamingEncounterGuid) {
                        handleSetStreamingEncounter(e.encounterGuid, e.encounterName)
                        log = `Found stream: ${e.encounterName} - (eGuid: ${e.encounterGuid})`
                    }
                });
                console.log(log)
            });
        }
    }, [socket]);

    const handleDropDownOptionClicked = (enc, openSessionTab=false) => {
        if(enc === null) {
            socket.emit("stopStreaming", enc.encounterGuid, enc.encounterName, sessionID)
            handleSetStreamingEncounter(null, null, false)
        } else if(enc.encounterGuid !== streamingEncounter.encounterGuid) {
            socket.emit("startStreaming", enc.encounterGuid, enc.encounterName, sessionID)
            handleSetStreamingEncounter(enc.encounterGuid, enc.encounterName, true)
        } 

        if(openSessionTab)
            handleOpenSession(sessionID)

    };

    useEffect(() => {
        const handlePlusMinus = (e) => {
            // Only trigger if not focusing an input, textarea, or contenteditable element
            const tag = document.activeElement.tagName.toLowerCase();
            const isEditable = document.activeElement.isContentEditable;
            if (tag === "input" || tag === "textarea" || isEditable) return;
            if (e.key === "=") {
                iconSizeChange("+");
            } else if (e.key === "-") {
                iconSizeChange("-");
            }
        };
        window.addEventListener("keydown", handlePlusMinus);
        return () => window.removeEventListener("keydown", handlePlusMinus);
    }, [streamingEncounter.encounterGuid])
    
    const iconSizeChange = (sizeType) => {
        socket.emit("iconSizeChange", sizeType, streamingEncounter.encounterGuid, username)
    };

    let buttonString = streamingEncounter.encounterGuid === null ? `Stream Player View...` : "Streaming "
    if(username === 'Username') {
        buttonString = "Sign in to stream"
    }

    return (
        <>
            <div className="dropdown" ref={dropdownRef}>
                <button className="dmViewButton dropdownButton" style={{borderRight: 0, paddingTop: '0px', paddingRight: '10px'}} disabled={username === 'Username'} onClick={() => setIsOpen(!isOpen)}>
                    <i>{buttonString}</i> 
                    {streamingEncounter.encounterName !== null && 
                        <>
                            <img alt='streaming' className='streamingGif' src={streaming} />
                            <p style={{margin: 0, textWrap: 'nowrap'}}>
                                <b>{streamingEncounter.encounterName}</b>
                            </p>
                        </>
                    }
                </button>
                {isOpen && savedEncounters.length !== 0 && (
                    <ul className="dropdownMenu" style={{
                        maxHeight:"55vh",
                        borderTop: "2px solid rgb(105, 19, 19)",
                        paddingLeft: 0,
                        overflowX: 'hidden'
                    }}>
                        {username !== "Username" &&
                            <>
                                <input
                                    id='encounterSearch'
                                    type="text"
                                    placeholder="Search Encounters/Folders"
                                    value={search}
                                    onChange={e => setSearch(e.target.value)}
                                    style={{
                                        width: '97%',
                                        padding: "4px 0px 4px 2px",
                                        margin: '0',
                                        border: "2px solid rgb(157, 125, 72)",
                                        fontSize: "0.8em",
                                    }}
                                    autoFocus={true}
                                />
                                {streamingEncounter.encounterGuid !== null ? (
                                    <div style={{background: "white", padding: '0 12px 0 12px', borderBottom: '2px solid black', fontSize: '0.75em'}}> 
                                        {sessionID &&
                                            <>
                                                <li className='dropdown-item' style={{justifyContent: 'center'}} onClick={() => {handleOpenSession(sessionID)}}>
                                                    <strong>Open PlayerView</strong> 📺
                                                </li>
                                                <li className='dropdown-item' style={{justifyContent: 'center'}} onClick={() => {handleOpenSession(sessionID, true)}}>
                                                    <strong>Open Tv-Table View</strong> 📺
                                                </li>
                                            </>
                                        }
                                        <li className="dropdown-item" 
                                            onClick={() => {handleDropDownOptionClicked(null)}}
                                            style={{justifyContent: 'center', background: "white", textDecoration: 'underline', textDecorationThickness: '2px', textDecorationColor: 'red'}}
                                        >
                                            Stop Streaming
                                        </li>
                                    </div>
                                ) : (
                                    <li className='dropdown-item' style={{borderBottom: '2px solid black'}}>
                                        <strong>Select An Encounter To Stream</strong>
                                    </li>
                                )}
                                <FolderList
                                    folders={filteredFolders}
                                    onEncounterClick={handleDropDownOptionClicked}
                                    streamingEncounter={streamingEncounter}
                                    adminView={adminView}
                                    currentEncounter={{}}
                                    setCurrentEncounter={() => {}}
                                    collapsedFolders={collapsedFolders}
                                    setCollapsedFolders={setCollapsedFolders}
                                />
                            </>
                        }
                    </ul>
                )}
            </div>
            {sessionID && streamingEncounter.encounterGuid !== null &&
                <div className='magWrapper'>
                    <OptionButton imgClassName={'magOptions'} src={magPlus} message={<>Grow Icons <span style={{fontSize: "12px", fontFamily: "Courier New"}}>(Shortcut '=')</span></>} onClickFunction={()=> iconSizeChange("+")}/>
                    <OptionButton imgClassName={'magOptions'} src={magMinus} message={<>Shrink Icons <span style={{fontSize: "12px", fontFamily: "Courier New"}}>(Shortcut '-')</span></>} onClickFunction={()=> iconSizeChange("-")}/>
                </div>
            }
        </>
    );
};

export default DropDownSessionMenu;
